<template>
  <div>
    <p style="text-align: center">
      <span class="systemFont1">{{ $t("emailGroup.groupAnnouncement") }}</span>
    </p>
    <!-- 全员公告按钮 -->
    <el-row style="bottom: 35px">
      <el-col
          :span="23"
          style="height: 20px; line-height: 44px; margin-right: 65px"
      >
          <el-button type="p0403topButton"  @click="allAnnouncement()" style="float: right">{{
          $t("p0403.allStaffAnnouncement")
          }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" :offset="1">
        <el-table
          :data="emailGroupData"
          v-loading="pageLoading"
          style="width: 100%; margin-bottom: 75px"
        >
          <!-- Email群名称 -->
          <el-table-column
            prop="groupName"
            :label="$t('emailGroup.emailGroupName')"
            align="left"
            min-width="75"
          >
          </el-table-column>
          <!-- 群摘要/描述 -->
          <el-table-column
            prop="groupDescription"
            :label="$t('emailGroup.groupDescription')"
            align="left"
            min-width="75"
          >
          </el-table-column>
          <!-- 人数 -->
          <el-table-column
            prop="number"
            :label="$t('emailGroup.peopleCount')"
            align="right"
            min-width="20"
          >
          </el-table-column>
          <!-- 创建日期 -->
          <el-table-column
            prop="createTime"
            :label="$t('emailGroup.createDate')"
            align="center"
            min-width="75"
          >
          </el-table-column>
          <!-- 上次公告 -->
          <el-table-column
            prop="lastAnnouncement"
            :label="$t('emailGroup.lastAnnouncement')"
            :formatter="dateAndTimeFormat"
            align="center"
            min-width="50"
          >
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('emailGroup.operation')"
            align="center"
            min-width="45"
          >
            <template slot-scope="scope">
              <el-button @click="newAnnouncement(scope.row)" type="text">{{
                $t("emailGroup.newAnnouncement")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row><br /><br /></el-row>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
export default {
  data() {
    return {
      // 页面载入状态
      pageLoading: false,
      // 页面数据
      emailGroupData: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 全员公告按钮
    allAnnouncement(){
      // 跳转指定页面
      this.$router.push({
        path: "/views/Marketing/EmailMarketing/P0405",
        query: {
          groupName: "全员",
          emailGroupId: 0,
        }
      });
    },
    // 新公告按钮
    newAnnouncement(row) {
      // console.log(row);
      // 跳转指定页面
      this.$router.push({
        path: "/views/Marketing/EmailMarketing/P0405",
        query: {
          emailGroupId: row.emailGroupId,
          groupName: row.groupName
        }
      });
    },
    // 初始化
    init() {
      const loading = this.$loading({
        lock: true, //同v-loading的修饰符
        // text: "loading", //加载文案
        backgroundColor: "rgba(55,55,55,0.4)", //背景色
        // spinner: "el-icon-loading", //加载图标
        target: document.querySelector(".mainOne .is-scrolling-none") //loading需要覆盖的DOM节点，默认为body
      });
      let url = "/api/emailGroupView/getEmailGroupList";
      this.$http
        .post(url)
        .then(response => {
          if (response.data.code === 200) {
            this.emailGroupData = response.data.data;
            this.pageLoading = false;
            loading.close();
          } else {
            this.pageLoading = false;
            this.$message.error(response.data.message);
            loading.close();
          }
        })
        .catch(err => {
          //console.log(err)
          loading.close();
          this.pageLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 时间标准化
    dateAndTimeFormat(row) {
      if (row.lastAnnouncement != null && row.lastAnnouncement != "") {
        return moment(row.lastAnnouncement).format("YYYY-MM-DD HH:mm");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.el-button--p0403topButton:focus,
.el-button--p0403topButton {
  background-color: #00B0F0;
  border-color: rgb(0, 176, 240);
  height:35px;
  width: 100px;
  white-space: pre-wrap;
  padding: 0 15px;
  font-family: '微软雅黑';
  font-weight: 500;
  font-style: normal;
  color: #FFFFFF;
  font-size: 14px;
  line-height: 24px;
  border-radius: 7px;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/EmailMarketing/P0403.vue